export default `
window.API_STQR = (function(qr){
    const env = window["STQR_API_ENV"] || {};
    const statsUrl = env.statsUrl;
    const BE = env.serverRoot;
    const getPath = (type)=>{
        const urlEnd = type === 'video' ? qr.videoUrl : qr.audioUrl;
        console.log(urlEnd);
        var fullPath = "";
        if (urlEnd.startsWith("http")) {
            fullPath = urlEnd;
        } else {
            fullPath = env.mediaRoot  + urlEnd;
        }
        return fullPath;
    };
    const buildFullImageUrl = (urlEnd) => {
        let fullPath;
        if (urlEnd.startsWith("http")) {
            fullPath = urlEnd;
        } else {
            fullPath = env.mediaRoot + urlEnd;
        }

        return fullPath;
    };
    const getImagesPath = (images) => {
        return images.map(item => ({
            ...item,
            url: buildFullImageUrl(item.url)
        }));
    };
    // available for audio also
    async function presignFile(video) {
        const formData = new FormData();
        formData.append("files", video);
        const response = await fetch(BE+"uploads/presign", {
            method: 'POST',
            body: formData
        });
        const responseData = await response.json();
        return responseData;
    }
// available for audio also
    async function saveExperience(id, videoUrl, videoDuration, burnFields, mediaType, imageJson, isMailingAccepted, email) {
            const formData = new FormData();
            let headers = {};
            const isBurnt = qr.status === "BURNT";
            formData.append(isBurnt ? "id" : "shortlink_public_crypto_id", id.toString());
            if(mediaType == "audio"){
                formData.append("audio_url", videoUrl);
                formData.append("audio_duration", videoDuration.toString());
            }else if(mediaType == "video"){
                formData.append("video_url", videoUrl);
                formData.append("video_duration", videoDuration.toString());
            } else if(mediaType == "image" && imageJson){
                formData.append("photos_json", imageJson);
            }
            formData.append("field_values", burnFields);
            if(email){
                formData.append("notification_emails", email);
                formData.append("is_promotional_emailing_accepted", isMailingAccepted);
            }
            let url = BE+"shortlink-burns";
            if(isBurnt){
                url = BE+"shortlink-burns/"+id;
            }   
            const method = qr.status === "BURNT" ? "PUT" : "POST";
            const response = await fetch(url, {
                method: method,
                body:formData, 
                hedaers: headers
            });
            const responseData = await response.json();
            return responseData;
    }
// available for audio also
    async function sendToS3(videoFile, presigned_url, type, onProgress) {
        return new Promise((resolve, reject) => {
            if (!videoFile || !presigned_url) {
                reject(new Error("Invalid video file or presigned URL"));
                return;
            }
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', presigned_url, true);

            xhr.upload.onprogress = function (event) {
                if (event.lengthComputable) {
                    const percent = (event.loaded / event.total) * 100;
                    onProgress(percent);
                }
            };
            xhr.onload = function () {
                if (xhr.status === 200) {
                    resolve()
                } else {
                 reject(new Error("Upload failed with status: " + xhr.status));
                }
            };
            xhr.onerror = function () {
                reject(new Error("Upload failed due to a network error"));
            };
            xhr.setRequestHeader('Content-Type', videoFile.type);
            xhr.send(videoFile);
        });
    }

    function convertCamelToSnake(obj) {
        // If the input is an array, recursively process each element
        if (Array.isArray(obj)) {
            return obj.map(item => convertCamelToSnake(item));
        }
    
        // If the input is an object, process its keys and values
        if (obj !== null && typeof obj === "object") {
            return Object.keys(obj).reduce((result, key) => {
                const value = obj[key];
    
                // Convert camelCase key to snake_case
                const snakeKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
    
                result[snakeKey] = value;
    
                return result;
            }, {});
        }
        if (typeof obj === "string") {
            return obj.replace(/([A-Z])/g, "_$1").toLowerCase();
        }
    
        // Return the value as-is if it's not an object or array
        return obj;
    }

    function getUserOS() {
        const platform = navigator.platform;
        let osName = "Unknown OS";
    
        if (platform.includes("Win")) {
            osName = "Windows";
        } else if (platform.includes("Mac")) {
            osName = "MacOS";
        } else if (platform.includes("X11") || platform.includes("Linux")) {
            osName = "Linux";
        }
    
        return osName;
    }

    async function logScan(fp, action, actionData) {
        const dts = Math.floor(new Date().getTime() / 1000);
        const dtms = Date.now();
        const offsetMinutes = new Date().getTimezoneOffset();
        const timezoneOffset = offsetMinutes / -60;
        const uniqueTmp = Date.now() - Math.floor(Math.random() * 10000);
        try {
            const reqData = {
                dt: dts,
                ms: dtms,
                timezone: timezoneOffset,
                sessionId: uniqueTmp.toString(),
                userId: qr.userId.toString(),
                projectId: qr.projectId,
                shortlinkId: qr.shortlinkId,
                fp: fp.toString(),
                object: "shortlink",
                event: action,
                osName: getUserOS(),
                country: qr.country,
                city: qr.city,
                organizationId: qr.organizationId.toString(),
            };
            if(actionData){
                reqData.data = actionData
            }
            const stqr = "stqr.tracks";
            const p = convertCamelToSnake(reqData);
            const data = "stqr.tracks;"+uniqueTmp+";"+JSON.stringify(p);
            const response = await fetch(statsUrl, {
                method: "POST",
                body: data
            });

            if (response.status === 200) {
                return response;
            }
        } catch (error) {
            return Promise.reject(error);
        }
    }

    return {
        version: "1.0",
        hasVideo(){
            return qr.status === "BURNT" && qr.videoUrl;
        },
        hasAudio(){
            return qr.status === "BURNT" && qr.audioUrl;
        },
        hasImages(){
            return qr.status === "BURNT" && qr.photos && qr.photos.length > 0;
        },
        langFromUrl(){
            return qr.langUrl;
        },
        async resetMedia(){
            try{
                if(qr.canAnyOneChangeBurn){

                    const url = BE+"shortlink-burns"+"/"+qr.shortlinkPublicCryptoId;
                    const res = await fetch(url,{
                        method: 'DELETE',
                    });
                    if(res.status === 200){
                        qr.status = "BLANK";
                        qr.reBurn =  true;
                        return Promise.resolve(true);
                    }
                }else {
                    qr.status = "BURNT";
                    qr.reBurn =  false;
                    return Promise.reject("You are not allowed to reset the video");
                }
            }catch(e){
                console.error(e);
                return Promise.resolve(false);
            }
        },
        async resetVideo(){
            await this.resetMedia();
        },
        async sendLog(event, data){
            logScan(qr.fp, event, data);
        },
        async sendVideo(videoFile, onProgress, userData) {
                try {
                    const presignedFile = await presignFile(videoFile.name);
                    const { path_to_save, presigned_url } = presignedFile[0];
                    const awsFile = await sendToS3(videoFile, presigned_url, videoFile.type, onProgress);
                    const savedFile = await saveExperience(
                        qr.shortlinkPublicCryptoId,
                        path_to_save,
                        qr.maxBurningVideoLength,
                        JSON.stringify([]),
                        'video',
                        undefined,
                        userData.isMailingAccepted,
                        userData.email
                    );
                    logScan(qr.fp, "burn", savedFile.id);
                    qr.videoUrl = savedFile.video_url;
                    qr.audioUrl = savedFile.audio_url;
                    qr.photos = savedFile.photos;
                    qr.status = "BURNT";
                    return getPath('video');
                } catch (e) {
                    throw new Error(e)
                    console.error(e);
                }
        },
        async sendAudio(audioFile, onProgress, userData){
            try {
                await this.resetMedia();
                const presignedFile = await presignFile(audioFile.name);
                const { path_to_save, presigned_url } = presignedFile[0];
                const awsFile = await sendToS3(audioFile, presigned_url, audioFile.type, onProgress);
                const savedFile = await saveExperience(
                    qr.shortlinkPublicCryptoId,
                    path_to_save,
                    qr.maxBurningVideoLength,
                    JSON.stringify([]),
                    'audio',
                    undefined,
                    userData.isMailingAccepted,
                    userData.email
                );
                logScan(qr.fp, "burn", savedFile.id);
                qr.audioUrl = savedFile.audio_url;
                qr.photos = savedFile.photos;
                qr.videoUrl = savedFile.video_url;
                qr.status = "BURNT";
                return getPath('audio');
            } catch (e) {
                throw new Error(e)
                console.error(e);
            }
        },
        async sendImages(images, onProgress, userData) {
            if(qr.status === 'BURNT'){
                await sendImageOneByOne(images, onProgress, userData);
                return;
            }
            try {
                // 1. Presign all files
                const presignedFiles = await Promise.all(
                    images.map(file => presignFile(file.name))
                );
                // 2. Upload all files to AWS
                const uploadedFiles = await Promise.all(
                    images.map((file, index) => {
                        const { path_to_save, presigned_url } = presignedFiles[index][0];
                        return sendToS3(
                            file,
                            presigned_url,
                            file.type,
                            onProgress
                        ).then(() => ({
                            url: path_to_save
                        }));
                    })
                );
                const savedFile = await saveExperience(
                    qr.shortlinkPublicCryptoId,
                    undefined,
                    undefined,
                    JSON.stringify([]),
                    'image',
                    JSON.stringify(uploadedFiles),
                    userData.isMailingAccepted,
                    userData.email
                );
                logScan(qr.fp, "burn", savedFile.id);
                qr.photos = savedFile.photos;
                qr.videoUrl = savedFile.video_url;
                qr.audioUrl = savedFile.audio_url;
                qr.status = "BURNT";
                return savedFile;
            } catch (e) {
                console.error("sendImages error:", e);
                throw new Error(e);
            }
        },

        async sendImageOneByOne(images, onProgress, userData){
            try {
                const presignedFiles = await Promise.all(
                    images.map(file => presignFile(file.name))
                );
                // 2. Upload all files to AWS
                const uploadedFiles = await Promise.all(
                    images.map((file, index) => {
                        const { path_to_save, presigned_url } = presignedFiles[index][0];
                        return sendToS3(
                            file,
                            presigned_url,
                            file.type,
                            onProgress
                        ).then(() => ({
                            url: path_to_save
                        }));
                    })
                );
                const savedFile = await Promise.all(
                    uploadedFiles.map(file => {
                        url = BE+"shortlink-burns"+"/"+qr.shortlinkPublicCryptoId+"/photos";
                        const fd = new FormData();
                        fd.append('url', file.url);
                        return fetch(url, {
                            method: 'POST',
                            body: fd
                        }).then(res => res.json());
                    })
                );
                if(qr.photos && qr.photos.length){
                    qr.photos.push(...savedFile);
                } else {
                    qr.photos = savedFile;
                }
                    console.log(qr.photos,'all');
                qr.videoUrl = savedFile.video_url;
                qr.audioUrl = savedFile.audio_url;
                await saveExperience(
                    qr.shortlinkPublicCryptoId,
                    undefined,
                    undefined,
                    JSON.stringify([]),
                    'image',
                    undefined,
                    userData.isMailingAccepted,
                    userData.email
                )
            } catch (e) {
                console.error("sendImages error:", e);
                throw new Error(e);
            }
        },

        async deleteImagesOneByOne(images, onProgress, userData){
            try {
                const deleteAll = await Promise.all(
                    images.map(image => {
                        url = BE+"shortlink-burns"+"/"+qr.shortlinkPublicCryptoId+"/photos/"+image;
                        fetch(url, {
                            method: 'DELETE'
                        });
                    })
                );
                qr.photos = qr.photos.filter((img)=>!images.includes(img.id));
                console.log(qr.photos);
            } catch (error) {
                console.error("sendImages error:", e);
                throw new Error(e);
            }
        },

        async sendThanksEmail(userData){ 
            try {
                url = BE+"shortlink-burns"+"/"+qr.shortlinkPublicCryptoId+"/thank-you-emails";
                const fd = new FormData();
                fd.append('shortlink_public_crypto_id', qr.shortlinkPublicCryptoId);
                fd.append('email', userData.email);
                fd.append('message', userData.thankMsg);
                fd.append('is_promotional_emailing_accepted', userData.emailingAccepted);
                const response = await fetch(url, {
                    method: 'POST',
                    body: fd
                });
            } catch(e){
                console.error(e);
                throw new Error(e);
            }
        },

        getVideoPath(){
            return getPath('video');
        },
        getAudioPath(){
            return getPath('audio');
        },
        getImagesObj(){
            return getImagesPath(qr.photos);
        },
        isReported(){
            return qr.projectReported;
        },
        isBanned(){
            return qr.projectBanned;
        },
        reportVideo(reason, params){
            if(!params){params = {};}
            const ar = [
                "HATE",
                "NUDITY_SEX",
                "ANIMAL_CRUELTY",
                "SUICIDE_SELF_INJURY",
                "BULLYING",
                "FAKE_NEWS",
                "VIOLENCE",
                "SCAM",
                "SALE_ILLEGAL",
                "INTELLECTUAL_VIOLATION",
                "CHILDREN_SAFETY"
            ];
            const reasonId = ar.indexOf(reason);
            if(ar.indexOf(reason)<0){
                console.warn("Reason of report must me one of the among:", ar);
                return;
            }
            const formData = new FormData();
            formData.append("shortlink_id", qr.shortlinkId.toString());
            formData.append("shortlink_report_type_id", reasonId.toString());
            formData.append("first_name", params['reporterFirstName']);
            formData.append("last_name", params['reporterLastName']);
            formData.append("email", params['reporterEmail']);
            formData.append("message", params['reporterMessage']);

            const response = fetch(BE+"shortlink-reports", {
                method: 'POST',
                headers: {
                },
                body: formData
            });
            
            return response.then(r=>r.json());
        },
        hasBurned(){
            return qr.status === "BURNT";
        },
        isThankYouEmailAllowed(){
            return qr.isThankYouEmailAllowed;
        },
        isThankYouEmailSent(){
            return qr.isThankYouEmailSent;
        }
    };
})`;
